module.exports = __webpack_public_path__ + "img/dropdown-profile.231d8cf6.svg";